import LogRocket from 'logrocket';

export default {
  data() {
    return {
    };
  },
  mounted() {
    /* this.trackPage(); */
  },
  methods: {
    initLogRocket() {
      // initialise logrocket
      if (LogRocket && LogRocket._isInitialized === false) {
        try {
          LogRocket.init('tiwbe0/ttt-js-logrocket', {
            console: {
              // only warnings and errors enabled
              isEnabled: {
                log: false,
                debug: false,
              },
            },
            // sanitize credit card input form
            dom: {
              inputSanitizer: true,
            },
            // sanitize card payment form submit
            network: {
              requestSanitizer: (request) => {
                // always scrub auth header
                request.headers.Authorization = null;
                request.headers.authorization = null;
                if (request.url.toLowerCase().indexOf('pay/card') !== -1 || request.url.toLowerCase().indexOf('auth') !== -1) {
                  // scrub out the pay and auth request body
                  request.body = null;
                }
                return request;
              },
              responseSanitizer: (response) => {
                if (response.url.toLowerCase().indexOf('pay/card') !== -1 || response.url.toLowerCase().indexOf('auth') !== -1) {
                  // scrub out the pay and auth response body
                  response.body = null;
                }
                return response;
              },
            },
          });
          if (this.$store.getters['users/loggedInUser']) {
            // identify user for this logrocket session
            LogRocket.identify(this.$store.getters['users/loggedInUser'].id, {
              email: this.$store.getters['users/loggedInUser'].email,
            });
          }
        } catch (er) {
          console.log(er);
        }
      } else if (LogRocket) {
        // logrockets initialised - make sure to set identity
        if (this.$store.getters['users/loggedInUser']) {
          // identify user for this logrocket session
          LogRocket.identify(this.$store.getters['users/loggedInUser'].id, {
            email: this.$store.getters['users/loggedInUser'].email,
          });
        }
      }
    },
  },
};
